export default "__VITE_ASSET__CaXjoH6f__"